// Why: the one committed source of the running version (app-baseline 01-identity §1.1).
// VERSION_MAJOR is hand-set for significant releases. VERSION_BUILD is advanced by
// .githooks/pre-commit on every commit and must never be edited by hand.
export const VERSION_MAJOR = 1;
export const VERSION_BUILD = 238;
export const APP_VERSION = `${VERSION_MAJOR}.${VERSION_BUILD}`;
